import './directives'
import './filters'
import './googleAnalytics'
import './sentry'
import './virtualScroller'

import Vue from 'vue'
import AsyncComputed from 'vue-async-computed'

Vue.use(AsyncComputed)
